import { VisiblityElement } from '../snippets/visibility/visibility'
import { NativeFetcher } from './fetch'

export class Cart extends NativeFetcher {
  // Node IDs
  static ID__MINI_CART = 'mini-cart'
  static CART_UPDATE_EVENT = 'CART_UPDATE_REQUESTED'

  // DOM Elements IDS
  static ID__CART_COUNT = '#cart-count'

  // Endpoints
  static ENDPOINT__GET_CART = '/cart?view=ajax'
  static ENDPOINT__CLEAR_CART = '/cart/clear.js'
  static ENDPOINT__ADD_LINE_ITEMS = '/cart/add.js'
  static ENDPOINT__UPDATE_LINE_ITEMS = '/cart/update.js'
  static ENDPOINT__CHANGE_LINE_ITEM = '/cart/change.js'

  // Instance variables
  value // The actual cart

  constructor() {
    super()
    /** Add Event Listeners */
    this.addEventListeners()

    /** On initialisation get the cart from shopify
     * set the instance variable 'value' with the current
     * customer cart.
     */
    this.getCart(true)
  }

  // Static Cart Handlers
  EVENT_UPDATE_CART_COUNT = 'updateCartCount'
  static dispatchUpdateCartCount(count, isInitial = false) {
    document.dispatchEvent(
      new CustomEvent(Cart.EVENT_UPDATE_CART_COUNT, {
        detail: {
          count,
          isInitial
        }
      })
    )
  }

  // Static Cart Handlers
  static EVENT_RENDER_MINI_CART = 'renderMiniCart'
  static dispatchRenderMiniCart(action) {
    document.dispatchEvent(
      new CustomEvent(Cart.EVENT_RENDER_MINI_CART, {
        detail: {
          action
        }
      })
    )
  }

  get CART_UPDATE_EVENT() {
    return Cart.CART_UPDATE_EVENT
  }

  addEventListeners() {
    document.addEventListener(Cart.EVENT_UPDATE_CART_COUNT, this.handleCartCount)
    document.addEventListener(Cart.EVENT_RENDER_MINI_CART, this.handleMiniCartRender.bind(this))
  }

  static dispatchOpenMiniCart() {
    VisiblityElement.dispatchShow(Cart.ID__MINI_CART)
  }

  dispatchOpenMiniCart() {
    Cart.dispatchOpenMiniCart()
  }

  static dispatchHideMiniCart() {
    VisiblityElement.dispatchHide(Cart.ID__MINI_CART)
  }

  dispatchHideMiniCart() {
    Cart.dispatchHideMiniCart()
  }

  // API CALLS - 1:1 with Shopify Docs

  async getCart(isInitial = false) {
    this.value = await this.get(Cart.ENDPOINT__GET_CART)
    window.Cart = this // hacky fix due to a weird issue where window.Cart.value is not updated
    Cart.dispatchUpdateCartCount(this.value.item_count, isInitial)
  }

  /**
   * Adds line item to cart asynchronously
   * Can pass 1 line item or many
   * https://shopify.dev/docs/api/ajax/reference/cart#post-locale-cart-add-js
   */
  async addLineItems(items, options = {}) {
    const { silent = false } = options

    const body = {
      items: items.length ? items : [items]
    }

    const data = await this.post(Cart.ENDPOINT__ADD_LINE_ITEMS, body)
    if (data && !silent) Cart.dispatchOpenMiniCart()
    Cart.dispatchRenderMiniCart(true)
    this.getCart()

    return data
  }

  /**
   * Update line item in cart asynchronously
   * Can pass 1 line item or many
   * https://shopify.dev/docs/api/ajax/reference/cart#post-locale-cart-update-js
   */
  async updateLineItems(items, options = {}) {
    const { silent = true } = options

    const body = {
      updates: items
    }

    const data = await this.post(Cart.ENDPOINT__UPDATE_LINE_ITEMS, body)
    if (data && !silent) Cart.dispatchOpenMiniCart()
    this.getCart()
    return data
  }

  /**
   * Changes line item in cart asynchronously
   * Can only update 1 at a time
   * https://shopify.dev/docs/api/ajax/reference/cart#post-locale-cart-change-js
   */

  async changeLineItem(item, options = {}) {
    const { silent = true } = options

    const data = await this.post(Cart.ENDPOINT__CHANGE_LINE_ITEM, item)
    if (data && !silent) Cart.dispatchOpenMiniCart()
    this.getCart()
    return data
  }

  /**
   * Clears Cart
   * Can only update 1 at a time
   * https://shopify.dev/docs/api/ajax/reference/cart#post-locale-cart-change-js
   */

  async clearCart(options = {}) {
    const { silent = true } = options

    const data = this.post(Cart.ENDPOINT__CLEAR_CART, {})
    if (data && !silent) Cart.dispatchOpenMiniCart()
    this.getCart()
    return data
  }

  // Auxillary API handlers - wrappers for additional common cases

  async removeLineItem(id, options) {
    const items = {
      [id]: 0
    }
    return await this.updateLineItems(items, options)
  }

  async updateLineItemQuantity(item, options) {
    const { id, quantity } = item
    const items = {
      [id]: quantity
    }

    return await this.updateLineItems(items, options)
  }

  handleCartCount(event) {
    const cartCountDOMElement = document.querySelector(Cart.ID__CART_COUNT)
    if (!cartCountDOMElement) return
    /** Get item count  */
    const { count } = event.detail

    /** Check if cart count is hidden */
    const cartCountDOMClasses = cartCountDOMElement.classList

    /** Toggle cart count badge if the count is greater than 0 */
    if (count > 0) {
      cartCountDOMClasses.contains('hidden') && cartCountDOMClasses.remove('hidden')
    } else {
      cartCountDOMClasses.add('hidden')
    }

    /** Apply new item count  */
    cartCountDOMElement.innerHTML = `${count}`
  }

  triggerCartUpdate() {
    const event = new CustomEvent(Cart.CART_UPDATE_EVENT, {
      detail: { timestamp: Date.now() }
    })
    document.dispatchEvent(event)
  }

  /**
   * Handles the mini-cart render
   * The mini-cart preact component contains a useUrl hook
   * that will re-render the component when the url changes updates.
   *
   */
  handleMiniCartRender() {
    this.triggerCartUpdate()
  }
}

const cart = new Cart()
export { cart }
